import React from 'react';
import PropTypes from 'prop-types';

const Payouts = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.9856 14.2869V20.1042C22.9856 21.7019 21.6883 22.9992 20.0906 22.9992H19.3395C20.036 22.9992 20.0906 21.0191 20.0906 20.1042V17.1819C20.0906 16.3898 20.4183 15.6661 20.9372 15.1335C21.4562 14.6146 22.1799 14.2869 22.9856 14.2869Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M9.68477 1.01367C9.68477 2.61139 8.38748 3.90868 6.78977 3.90868H3.89477V4.35931C3.89477 4.35931 3.7309 1.01367 4.63218 1.01367H9.68477Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M19.3396 23.0001H1V3.90947C1 2.31176 2.29729 1.01447 3.895 1.01447H4.63241C3.73113 1.01447 3.895 4.3601 3.895 4.3601V20.1051H20.0906C20.0906 21.02 20.036 23.0001 19.3396 23.0001Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M23.0401 2.54309V11.4056C22.2481 11.4056 21.5243 11.0779 20.9917 10.559C20.4728 10.0401 20.1451 9.3163 20.1451 8.51062V3.90866H14.7238L14.6419 3.88134L13.0032 2.24266C12.1838 1.42332 12.771 1.10924 12.9486 1.02731C12.9622 1.02731 12.9895 1.01365 13.0168 1.01365C13.1261 0.999997 13.2217 1 13.3309 1H21.497C22.3573 1.01366 23.0401 1.71009 23.0401 2.54309Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M13.0166 1.0274C13.003 1.04104 12.9894 1.04104 12.9621 1.04104C13.003 1.04104 13.0166 1.0274 13.0166 1.0274Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M15.9669 5.07016L15.9526 5.05585C15.9526 5.07016 15.9526 5.07016 15.9669 5.07016Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M12.976 1.05464L12.1157 1.35506L12.4434 2.43386L13.6997 4.46856L14.6556 3.89502L17.9057 3.90868V1.01367L12.976 1.05464Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M17.2909 8.68825L10.7089 15.2703C9.57544 14.1369 9.57544 12.307 10.7089 11.1736L14.2866 7.5958L11.6511 4.96026C10.9547 4.26382 10.7771 3.22598 11.2005 2.33837C11.4053 1.91504 11.733 1.57365 12.129 1.3415C12.3885 1.19129 12.6889 1.08204 12.9894 1.04108C12.7982 1.12301 12.2246 1.43709 13.044 2.25643L14.6827 3.89511L14.7646 3.92242H14.669L17.2909 6.54431C17.8917 7.1315 17.8917 8.10106 17.2909 8.68825Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

Payouts.propTypes = {
  fill: PropTypes.string,
};

export default Payouts;
